import { WizardSession } from './types';

const buildKey = (userId: number | null) => `createPlanWizard_session_user_${userId ?? 'anon'}`;

export const saveWizardSession = (userId: number | null, data: object) => {
  try {
    localStorage.setItem(buildKey(userId), JSON.stringify(data));
  } catch (e) {
    console.warn('saveWizardSession failed', e);
  }
};

export const clearWizardSession = (userId: number | null) => {
  try {
    localStorage.removeItem(buildKey(userId));
  } catch (e) {
    console.warn('clearWizardSession failed', e);
  }
};

export const loadWizardSession = (userId: number | null): WizardSession | null => {
  try {
    const raw = localStorage.getItem(buildKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};